<template>
  <el-dialog
    :visible.sync="visible"
    :title="$t('txmis.rebateComponents.add')"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >
    <el-form
      :model="dataForm"
      ref="dataForm"
      @keyup.enter.native="dataFormSubmitHandle()"
      :label-width="'200px'"
    >
      <el-form-item label="交易账号" prop="accountNo">
        <el-input v-model="dataForm.accountNo" placeholder="交易账号"
                  @change="changeAccountNo(dataForm.accountNo)"></el-input>
      </el-form-item>

      <el-form-item label="存款人" prop="proposer">
        <el-input v-model="dataForm.proposer" placeholder="存款人"></el-input>
      </el-form-item>

      <el-form-item label="交易平台">
        <el-select v-model="dataForm.platform" placeholder="交易平台" clearable>
          <el-option
            v-for="item in platformList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item prop="gatewayAmount" label="发给支付平台金额">
        <el-input v-model="dataForm.gatewayAmount"></el-input>
      </el-form-item>

      <el-form-item label="存款途径">
        <el-select v-model="dataForm.bankPayMethod" placeholder="选择" @change="changeBankPayMethod" clearable>
          <el-option
            v-for="item in bankPayMethods"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
      </el-form-item>

      <el-form-item label="支付平台结算币种" prop="gatewayCurrency">
        <el-input v-model="dataForm.gatewayCurrency" :placeholder="支付平台结算币种"></el-input>
      </el-form-item>

      <el-form-item label="公司收款银行">
        <el-select v-model="dataForm.bankPayName" placeholder="公司收款银行" @change="changeBankPayName" clearable>
          <el-option
            v-for="item in bankList"
            :key="item.bankCode"
            :label="item.bankNameEN"
            :value="item.bankCode">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
      </el-form-item>

      <el-form-item label="收款人姓名" prop="bankAccountName">
        <el-input v-model="dataForm.bankAccountName" placeholder="收款人姓名"></el-input>
      </el-form-item>

      <el-form-item label="提案时间">
        <el-date-picker
          v-model="dataForm.createDate" value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="提案时间">
        </el-date-picker>
      </el-form-item>

    </el-form>

    <template slot="footer">
      <el-button @click="visible = false">{{$t('txmis.rebateComponents.cancel')}}</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="dataFormSubmitHandle()"
      >{{$t('txmis.rebateComponents.confirm')}}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
    import debounce from "lodash/debounce";
    import URL from '@/views/newmis36/util/url';
    import Qs from 'qs';

    export default {
        data() {
            return {
                tabName: 'first',
                loading: false,
                visible: false,
                bankList: [],
                customerParam: {},
                bankPayMethods: [
                    {
                        value: 'P',
                        label: "internet Bank"
                    },
                    {
                        value: 'T',
                        label: "ATM"
                    },
                    {
                        value: 'RE',
                        label: "Counter deposit"
                    },
                    {
                        value: 'O',
                        label: "Other"
                    }
                ],
                platformList: [
                    {
                        value: 'GTS2',
                        label: "TREX"
                    },
                    {
                        value: 'MT5',
                        label: "MT5"
                    }
                ],
                dataForm: {
                    accountNo: '',
                    proposer: '',
                    platform: '',
                    gatewayAmount: '',
                    bankPayMethod: '',
                    gatewayCurrency: '',
                    bankPayAccount: '',
                    bankPayName: '',
                    bankAccountName: '',
                    createDate: '',
                    issueBankName: '',
                    depositBankname: '',

                },
            };
        },
        mounted() {
        },
        methods: {
            init() {
                this.clearFormData();
                this.visible = true;
                this.$nextTick(() => {
                    this.$refs["dataForm"].resetFields();
                });

                this.dataForm.bankPayMethod = "P";
                this.dataForm.issueBankName = "internet Bank";
                this.dataForm.gatewayCurrency = "VND";
                this.dataForm.accountCurrency = "USD";
                this.dataForm.payCurrency = "USD";
            },
            clearFormData() {
                for (let key in this.dataForm) {
                    this.dataForm[key] = "";
                }
            },
            dataChanage(url, option, suc, fail) {
                this.$axios.post(url, Qs.stringify(option || {})).then(res => {
                    if (suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if (fail && (typeof fail == 'function')) fail(res);
                })
            },
            changeAccountNo(val) {
                if (val != null && val.length > 7) {
                    this.getBankList(val);
                }
            },
            changeBankPayMethod(val) {
                let obj = {};
                obj = this.bankList.find((item) => {
                    return item.value === val;
                });
                this.dataForm.issueBankName = obj.label;
            },
            changeBankPayName(val) {
                let obj = {};
                const index = this.bankList.findIndex(d => d.bankCode === val);
                obj = this.bankList[index];
                this.dataForm.depositBankname = obj.bankNameEN;
            },
            isEmpty(obj) {
                return !Object.getOwnPropertyNames(obj).length && !Object.getOwnPropertySymbols(obj).length;
            },
            getBankList(customerNumber) {
                this.$axios.get(URL.payment.getCustomerInfo + "?customerNumber=" + customerNumber).then(res => {
                    if (res.code == 0) {
                        let bankLists = res.result.banks;
                        this.customerParam = res.result.customer;
                        if (bankLists.length <= 0) {
                            let newBank = {};
                            newBank.bankCode = "VCB";
                            newBank.bankNameEN = "Vietcombank";
                            this.bankList.push(newBank);
                        }
                        if (!isEmpty(this.customerParam)) {
                            this.dataForm.proposer = this.customerParam.englishFirstName + " " + this.customerParam.englishLastName;
                        }
                        this.dataForm.platform = 'GTS2';
                    }
                });
            },
            // 表单提交
            dataFormSubmitHandle: debounce(
                function () {
                    this.$refs["dataForm"].validate(valid => {
                        if (!valid) {
                            return false;
                        }
                        this.loading = true;
                        //根据是否包含id更新还是添加
                        this.dataChanage(URL.payment.supplementSave, this.dataForm, res => {
                            this.loading = false;
                            if (res.code == 0) {
                                this.$message({
                                    message: "提交成功",
                                    type: "success",
                                    duration: 500,
                                    onClose: () => {
                                        this.visible = false;
                                        this.$emit("refreshDataList");
                                    }
                                });
                            } else {
                                this.$message.error("提交失败");
                            }
                            this.visible = false;
                        }, fail => {
                            this.loading = false;
                        })
                    });
                },
                1000,
                {leading: true, trailing: false}
            )
        }
    };
</script>
